import React, { useEffect } from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer';
import StatsSection from '../../components/StatsSection';
import ProcessSection from '../../components/ProcessSection';
import Newsletter from '../../components/Newsletter';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";

const FaqItem = ({ question, answer, defaultOpen = false }) => {
  const [open, setOpen] = React.useState(defaultOpen);
  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button
          className={`accordion-button ${open ? '' : 'collapsed'}`}
          type="button"
          onClick={() => setOpen(prev => !prev)}
        >
          {question}
        </button>
      </h2>
      <div className={`accordion-collapse collapse ${open ? 'show' : ''}`}>
        <div className="accordion-body">{answer}</div>
      </div>
    </div>
  );
};

export default function EmbroideryDigitizing() {

    const embroiderySteps = [
        { number: "01", title: "Submit Your Design", description: "Send us your logo or artwork in any format such as JPG, PNG, PDF, or AI.", icon: "📤" },
        { number: "02", title: "Digitizing & Optimization", description: "Our experts carefully convert your design into a precise embroidery file.", icon: "⚡" },
        { number: "03", title: "Quality Check", description: "We review stitch paths, density, and detailing to ensure perfect output.", icon: "✓" },
        { number: "04", title: "Final Delivery", description: "Receive your files in required formats like DST, PES, JEF, and more.", icon: "🚀" }
    ];

    return (

        <>

            <Helmet>
                <title>Embroidery Digitizing Services in Los Angeles, CA | Grand Indigo Embroidery</title>
                <meta name="description" content="Grand Indigo Embroidery offers expert embroidery digitizing services in Los Angeles, CA. Get precise logo digitizing with fast turnaround. Order today!" />
                <meta name="keywords" content="embroidery digitizing services, logo embroidery digitizing, custom embroidery digitizing, professional embroidery digitizing, order embroidery digitizing online, embroidery digitizing services, embroidery digitizing services in Los Angeles, logo digitizing Los Angeles CA" />
            </Helmet>

            <Header />

            <section className="breadcrumbsection">
                <div className='container'>
                    <h1>Embroidery Digitizing</h1>
                    <ul className='breadcrumblinks'>
                        <li><Link to="/">Home</Link></li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Services</li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Embroidery Digitizing</li>
                    </ul>
                </div>
            </section>


            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/embroidery1.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Precision. Detail. Perfection.</span>
                                <h3 className="case-study-title">Expert Embroidery Digitizing Services in Los Angeles</h3>
                                <p className="case-study-description">
                                    At Grand Indigo Embroidery, we provide professional embroidery digitizing services in Los Angeles, California, helping businesses transform their logos and artwork into high-quality, machine-ready embroidery files. Whether you're a clothing brand, embroidery shop, or business owner, precise digitizing is essential to achieving clean, sharp, and consistent stitch results across all types of garments and fabrics.
                                </p>
                                <p className="case-study-description">
                                    Our team specializes in converting complex designs into accurate stitch patterns that ensure smooth execution on all major embroidery machines. From simple logos to detailed artwork, we focus on stitch density, direction, and sequencing to maintain the integrity of your design. If you're searching for reliable logo embroidery digitizing services near you in Los Angeles, Grand Indigo Embroidery delivers results that meet professional industry standards every time.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <StatsSection />

            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Built for Performance</span>
                                <h3 className="case-study-title">Custom Logo Digitizing Solutions for Every Business</h3>
                                <p className="case-study-description">
                                    Grand Indigo Embroidery offers custom embroidery digitizing services tailored to a wide range of industries and applications. We understand that every design is unique, which is why our digitizing process is carefully adjusted based on fabric type, placement, and embroidery style. Whether it's for caps, jackets, uniforms, or promotional apparel, we ensure your design translates perfectly into embroidery.
                                </p>
                                <p className="case-study-description">
                                    Our services cover everything from logo digitizing for embroidery to specialized applications such as 3D puff, left chest logos, and large back designs. Businesses across Los Angeles trust us for consistent quality, fast turnaround, and attention to detail. If you're looking to order embroidery digitizing online or need a trusted local partner, Grand Indigo Embroidery combines expertise with efficiency to deliver outstanding results.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/embroidery2.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <ProcessSection steps={embroiderySteps} />


            <section className="faqs-section">
                <div className="container">
                    <div className="row mb-5">
                        <div className="col-12 text-center">
                            <h2 className="section-title">Frequently Asked Questions</h2>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="accordion" id="faqAccordion">

                                <FaqItem
                                    defaultOpen={true}
                                    question="What is embroidery digitizing and why is it important?"
                                    answer="Embroidery digitizing is the process of converting a logo or design into a stitch file that embroidery machines can read. High-quality digitizing ensures clean, professional embroidery results."
                                />

                                <FaqItem
                                    question="Do you offer embroidery digitizing services in Los Angeles?"
                                    answer="Yes, Grand Indigo Embroidery provides expert embroidery digitizing services in Los Angeles, California, serving local businesses as well as clients nationwide."
                                />

                                <FaqItem
                                    question="How long does it take to digitize a logo for embroidery?"
                                    answer="Turnaround time is typically between 12 to 24 hours depending on the complexity of the design."
                                />

                                <FaqItem
                                    question="Can I order embroidery digitizing services online?"
                                    answer="Absolutely. You can easily submit your design and order embroidery digitizing online, making the process fast and convenient."
                                />

                                <FaqItem
                                    question="What file formats do you provide?"
                                    answer="We deliver embroidery files in all major formats including DST, PES, JEF, and EXP to ensure compatibility with different embroidery machines."
                                />

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Newsletter />

            <Footer />
        </>
    )
}
